var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { resolve } from "url";
export default class Registry {
    constructor() {
        this.renderers = {};
        this.listeners = new Set();
    }
    register(name, renderer) {
        return __awaiter(this, void 0, void 0, function* () {
            this.renderers[name] = renderer;
            return renderer;
        });
    }
    addSceneChangeListener(sceneChangeListener) {
        return __awaiter(this, void 0, void 0, function* () {
            this.listeners.add(sceneChangeListener);
            return sceneChangeListener;
        });
    }
    getRenderer(name) {
        return this.renderers[name];
    }
    render(workspace) {
        window.workspace = workspace;
        window.resolve = resolve;
        this.deepRender(workspace, workspace.appIndex);
    }
    deepRender(obj, appIndex) {
        if (typeof (obj) !== 'object' || !obj) {
            return;
        }
        if (obj instanceof HTMLImageElement) {
            return;
        }
        if (obj instanceof HTMLCanvasElement) {
            return;
        }
        if (Array.isArray(obj)) {
            for (let i = 0; i < obj.length; i++) {
                this.deepRender(obj[i], appIndex);
            }
        }
        else {
            if (obj.renderers) {
                obj.renderers.forEach((renderer) => {
                    var _a;
                    (_a = this.renderers[renderer]) === null || _a === void 0 ? void 0 : _a.render(obj, appIndex);
                });
            }
            for (let i in obj) {
                if (!(obj[i] instanceof HTMLImageElement)) {
                    this.deepRender(obj[i], appIndex);
                }
            }
        }
    }
    onChange(app, changeApp) {
        this.listeners.forEach(listener => listener.onChange(app, changeApp));
    }
}
